import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-40 bg-brand-beige border-t border-brand-border">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-24">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-6">(08) — Common questions</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-medium">
              Ask us <span className="italic text-brand-brown">anything</span>.
            </h2>
            <p className="mt-8 text-brand-charcoal/70 leading-relaxed max-w-md">
              Can&apos;t find your answer here? Send us a note in the contact section below and we&apos;ll reply within 24 hours.
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-brand-brown/15"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="font-display text-xl md:text-2xl text-left hover:no-underline hover:text-brand-brown py-6 font-medium">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-charcoal/75 text-base leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
